import { render, staticRenderFns } from "./DeleteConfirmModal.vue?vue&type=template&id=b48ef232&scoped=true"
import script from "./DeleteConfirmModal.vue.js?vue&type=script&lang=js&external"
export * from "./DeleteConfirmModal.vue.js?vue&type=script&lang=js&external"
import style0 from "./DeleteConfirmModal.vue?vue&type=style&index=0&id=b48ef232&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48ef232",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog})
